import React, { useEffect, useState } from 'react';
import { Result, Button, Card, Space, Typography, Divider, message } from 'antd';
import { CloseCircleOutlined, HomeOutlined } from '@ant-design/icons';

import { Order } from '../../types';
import { formatAmount, formatDateTime } from '../../utils';

const { Text } = Typography;

const PaymentFailure: React.FC = () => {


  const [order, setOrder] = useState<Order | null>(null);

  useEffect(() => {
    const storedOrder = sessionStorage.getItem('currentOrder');

    if (storedOrder) {
      setOrder(JSON.parse(storedOrder));
    } else {
      message.error('支付信息丢失，请联系客服');
      // Optionally close the window or navigate to a specific error page
      // window.close(); 
    }
  }, []);

  // 生成交易流水号
  const transactionNo = 'TXN' + Date.now();

  if (!order) {
    return (
      <div className="empty-container">
        <Text>支付信息丢失，请联系客服</Text>
        <Button 
          type="primary" 
          onClick={() => window.close()} // Close the window if order is lost
          style={{ marginTop: 16 }}
        >
          关闭页面
        </Button>
      </div>
    );
  }



  const handleBackHome = () => {
    // 新标签页打开订单中心
    window.open('about:blank', '_blank');
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '40px 20px' }}>
      <Result
        icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
        status="error"
        title="支付失败"
        subTitle="很抱歉，本次支付未能成功完成，请重试或联系客服"
        extra={[
          <Button key="home" icon={<HomeOutlined />} onClick={handleBackHome} size="large" style={{ minWidth: 140 }}>
            返回订单中心
          </Button>,
        ]}
      />

      {/* 交易详情卡片 */}
      <Card 
        title="交易详情" 
        style={{ marginTop: 24 }}
        headStyle={{ background: '#fafafa', fontWeight: 600 }}
      >
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">订单号：</Text>
            <Text strong>{order.order_no}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">交易流水号：</Text>
            <Text strong>{transactionNo}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">付款方：</Text>
            <Text>{order.payer_name}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">收款方：</Text>
            <Text>{order.payee_name}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">支付方式：</Text>
            <Text>交e保支付</Text>
          </div>
          
          <Divider />
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">支付金额：</Text>
            <Text 
              strong 
              style={{ 
                fontSize: 18, 
                color: '#ff4d4f',
                fontFamily: 'monospace'
              }}
            >
              ¥{formatAmount(order.amount)}
            </Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">交易时间：</Text>
            <Text>{formatDateTime(new Date().toISOString())}</Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">交易状态：</Text>
            <Text style={{ color: '#ff4d4f' }}>
              失败
            </Text>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text type="secondary">失败原因：</Text>
            <Text style={{ color: '#ff4d4f' }}>
              授权超时/用户取消
            </Text>
          </div>
        </Space>
      </Card>




    </div>
  );
};

export default PaymentFailure;